import { Box } from "@mui/material";
import { Editor } from "./DocumentEditor/Editor";
import "./DocumentEditor/Editor.css";
import { Props } from "./DocumentBuilderType";
import { documentThemes } from "./DocumentTheme";

export function DocumentPage({ content, theme, setDocumentTheme }: Props) {
  const activeTheme =
    documentThemes.find((t) => t.id === theme) || documentThemes[0];

  return (
    <Box
      className={`pdf-section `}
      sx={{
        width: "100%",
        backgroundImage: activeTheme.backgroundImage
          ? `url(${activeTheme.backgroundImage})`
          : "none",
        backgroundSize: "cover",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
        backgroundColor: activeTheme.background
          ? `url(${activeTheme.background})`
          : "none",
        color: activeTheme.bodyColor,
        fontFamily: activeTheme.bodyFont,
        
        margin: "auto",
         px: { xs: 0, sm: 0, md: "20px" },
        transition: "all 0.3s ease",
      }}
    >
      <Editor
        content={content}
        setDocumentTheme={setDocumentTheme}
        documentTheme={activeTheme}
      />
    </Box>
  );
}
